export default __webpack_public_path__ + "static/media/Foto-05.476e0396.png";